<template>
  <div class="main-content">


    <div class="Maintop">
      <div class="top_1200">
        <div class="logo">
          <img style="width: 220px;cursor: pointer" src="../../assets/imgs/home-logo-ic.jpeg" @click="goHome">
          <img style="margin-left: 20px" src="../../assets/imgs/home-line-ic.png">
          <img style="margin-left: 20px;width: 360px" src="../../assets/imgs/home-logo-txt.png">
        </div>

        <van-image style="margin-bottom: 16px" fit="contain" width="204px" height="68px"
                   :src="require('../../assets/imgs/home-phone-ic.png')"/>
      </div>
    </div>

    <template v-if="isInit">
      <div style="height: 100vh">
        <empty-layout :state="emptyState" @emptyClick="getData"/>
      </div>
    </template>
    <template v-else>

      <div class="Maintop">
        <div class="top_bbb">
          <div class="nav_list">
            <div :class="$route.path == '/home' ? 'aaaa aaaa-select':'aaaa '" href="javascript:void(0)" @click="goHome">
              首页
            </div>
            <div :class="$route.path == '/aboutUs' ? 'aaaa aaaa-select':'aaaa '" href="javascript:void(0)"
                 @click="aboutUs">走进碳索
            </div>
            <div :class="$route.path == '/hexinYw' ? 'aaaa aaaa-select':'aaaa '" href="javascript:void(0)"
                 @click="hexinYw">业务范围/核心技术
            </div>


            <div :class="$route.path == '/team' ? 'aaaa aaaa-select':'aaaa '" href="javascript:void(0)"
                 @click="hexinTeam">研发平台/核心团队
            </div>
            <div :class="$route.path == '/anliYj' ? 'aaaa aaaa-select':'aaaa '" href="javascript:void(0)"
                 @click="anliYj">
              工程案例与业绩
            </div>
            <div :class="$route.path == '/newsCenter' ? 'aaaa aaaa-select':'aaaa '" href="javascript:void(0)"
                 @click="newsCenter">新闻中心
            </div>
            <div :class="$route.path == '/contactUs' ? 'aaaa aaaa-select':'aaaa '" @click="contactUs"
                 href="javascript:void(0)">联系我们
            </div>
          </div>
        </div>
      </div>

      <div class="liuyan-wrap" :style="liuyanStyle" v-if="isShowLiuyan">
        <div class="title-wrap">
          <div class="title-txt">
            请您留言
          </div>
          <div class="close-txt" @click="changeLiuyan">
            －
          </div>
        </div>

        <textarea v-model="detailVal"
                  placeholder="请在此输入留言内容，我们会尽快与您联系。（必填,240字以内。）"
                  class="nb-nodeboard-set-content nb-nodeboard-param"></textarea>

        <div class="imput-wrap">
          <img class="sfsd-img" src="../../assets/imgs/account.png">
          <input maxlength="30"
                 class="sidfjsiin" v-model="nameVal" type="text" placeholder="姓名">
        </div>
        <div class="imput-wrap">
          <img class="sfsd-img" src="../../assets/imgs/phone.png">
          <input maxlength="30"
                 class="sidfjsiin" v-model="phoneVal" type="number" placeholder="电话（必填）">
        </div>
        <div class="imput-wrap">
          <img class="sfsd-img" src="../../assets/imgs/email.png">
          <input maxlength="30"
                 class="sidfjsiin" type="text" v-model="emailVal" placeholder="邮箱">
        </div>
        <div class="imput-wrap">
          <img class="sfsd-img" src="../../assets/imgs/addr.png">
          <input maxlength="30"
                 class="sidfjsiin" type="text" v-model="addrVal" placeholder="地址">
        </div>
        <div style="width: 100%;margin-left:12px ">

          <div class="comm-btn" @click="sendLiuyan">发送</div>
        </div>
      </div>
      <div class="title-show-wrap" v-else>
        <div class="title-txt">
          请您留言
        </div>
        <div class="close-txt" @click="changeLiuyan">
          口
        </div>
      </div>

      <div class="qq-open">

        <img @click="openLiuyanCenter" class="liuyan-open" src="../../assets/imgs/liuyan-ic.png">
        <!--        <div style="height: 10px"></div>-->
        <!--        <div class="liuyan-open">-->
        <!--          <a :href="qqHref" target="_blank">-->
        <!--            <img class="open-qq-img" src="../../assets/imgs/qq.png">-->
        <!--          </a>-->
        <!--        </div>-->

      </div>

      <router-view/>
    </template>

    <!--    <div style="flex: 1;height: 0px">-->
    <!--    </div>-->
    <!--    <foot-view/>-->

    <div class="main-footer">

      <div class="addr-wrap">

        <div class="bb-txt">Copyright © 2018-2020碳索（杭州）能源环境科技有限公司 版权所有 Powered by EyouCms浙江ICP备19041624号</div>
        <div class="bb-txt">地址:浙江省杭州市西湖区西溪路525号C楼5295室 电话：13023631525</div>
      </div>

      <img src="../../assets/imgs/erwei-code.png">
    </div>
  </div>
</template>

<script>
import {Image as VanImage} from 'vant';
import {Toast} from 'vant';
import Vue from 'vue';
import FootView from "@/pages/main/fragment/footView";
import EmptyLayout from "@/pages/main/fragment/EmptyLayout";
import emailjs from 'emailjs-com'
import apiKeys from '@/utils/apikeys'


Vue.use(VanImage);
Vue.use(Toast);
export default {
  name: "main",
  components: {EmptyLayout, FootView},
  data() {
    return {
      active: 0,
      isShowLiuyan: false,
      nameVal: '',
      phoneVal: '',
      emailVal: '',
      addrVal: '',
      detailVal: '',
      emptyState: 0,
      liuyanStyle: '',
      // qqHref: 'tencent://message/?uin=1234567&Site=Sambow&Menu=yes',
      qqHref: 'https://wpa.qq.com/msgrd?v=3&uin=2440340053&site=qq&menu=yes',
    }
  },
  computed: {
    isInit() {
      return this.$store.state.hxjs.length == 0 || this.$store.state.lb.length == 0 || this.$store.state.gcal.length == 0
    }
  },

  watch: {
    isShowLiuyan(val) {

      if (!val) {

        this.detailVal = ''
        this.addrVal = ''
        this.emailVal = ''
        this.phoneVal = ''
        this.nameVal = ''
        this.liuyanStyle = ''
      }

    }
  },
  methods: {
    async getData() {

      this.emptyState = 0
      let res = await this.$store.dispatch('post', {
        url: 'home',
        data: {}
      }).catch((err) => {
        Toast.fail(err.message)
      })

      if (res) {
        console.log(res)
        let gsdt = res.data['公司动态']
        let gcal = res.data['工程案例']
        let xwzx = res.data['新闻资讯']
        let hxjs = res.data['核心技术']

        for (let i = 0; i < gsdt.length; i++) {
          let ttt = gsdt[i]
          let day = ttt.time.substring(8, 10)
          let month = ttt.time.substring(0, 7)
          ttt.day = day
          ttt.month = month
        }

        this.$store.commit('setHxjs', hxjs)
        this.$store.commit('setGcal', gcal)
        this.$store.commit('setLb', res.data['轮播'])
        this.$store.commit('setXwzx', xwzx)
        this.$store.commit('setGsdt', gsdt)
        this.$store.commit('setZpxx', res.data['招聘信息'])
        this.$store.commit('setHomeJs', res.data['走进探索'])
        this.$store.commit('setRlzy', res.data['人力资源'])
        this.$store.commit('setTpzj', res.data['核心团队'])
        this.$store.commit('setYfpt', res.data['研发平台'])
        this.$store.commit('setYfptBt', res.data['研发平台标题'])

      } else {
        this.emptyState = 1
        // emailjs.send('service_mhj9vbb',
        //     apiKeys.TEMPLATE_ID,
        //     {
        //       to: "1054230914@qq.com",
        //       // to: "1054230914@qq.com",
        //       name: '碳索网站',
        //       topic: "碳索网站",
        //       phone: '',
        //       message: '碳索网站接口挂了'
        //     }, apiKeys.USER_ID).then(
        //     result => {
        //       console.log(result.text)
        //     },
        //     error => {
        //       console.log(error.text)
        //     }
        // )
        emailjs.send('service_mhj9vbb',
            apiKeys.TEMPLATE_ID,
            {
              to: "442081456@qq.com",
              // to: "1054230914@qq.com",
              name: '碳索网站',
              topic: "碳索网站",
              phone: '',
              message: '碳索网站接口挂了'
            }, apiKeys.USER_ID).then(
            result => {
              console.log(result.text)
            },
            error => {
              console.log(error.text)
            }
        )
      }
    },
    changeLiuyan() {
      this.isShowLiuyan = !this.isShowLiuyan
    },
    openLiuyanCenter() {
      // if (!this.isShowLiuyan) {
      this.isShowLiuyan = true
      this.liuyanStyle = 'left: 50%;transform: translateX(-50%);top: 50%;transform: translateY(-50%);'
      // }
    },
    contactUs() {//联系我们
      if (this.$route.path != '/contactUs')
        this.$router.push('/contactUs')
    },
    goHome() {//返回首页
      if (this.$route.path != '/home') {
        this.$router.replace('/home')
      }
    },
    aboutUs() {//关于我们
      if (this.$route.path != '/aboutUs') {
        this.$router.replace('/aboutUs')
      }
    },
    hexinYw() {//核心业务
      if (this.$route.path != '/hexinYw')
        this.$router.replace('/hexinYw')
    },
    hexinTeam() {//核心团队
      if (this.$route.path != '/team')
        this.$router.replace('/team')
    },
    newsCenter() {//新闻
      if (this.$route.path != '/newsCenter')
        this.$router.replace('/newsCenter')
    },
    anliYj() {//案例
      if (this.$route.path != '/anliYj')
        this.$router.replace('/anliYj')
    },
    async sendLiuyan() {

      if (this.detailVal == '' || this.phoneVal == '') {
        Toast.fail('请输入留言内容和电话');
        return
      }
      if (this.nameVal.length > 20) {
        Toast.fail('姓名长度不大于20');
        return
      }
      if (this.emailVal.length > 50) {
        Toast.fail('邮箱长度不大于50');
        return
      }
      if (this.addrVal.length > 50) {
        Toast.fail('地址长度不大于50');
        return
      }
      if (this.phoneVal.length > 20) {
        Toast.fail('手机号格式不正确');
        return
      }
      let data = {
        name: this.nameVal,
        telephone: this.phoneVal,
        email: this.emailVal,
        address: this.addrVal,
        detail: this.detailVal,
      }
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '...'
      });
      let res = await this.$store.dispatch('post', {url: "leavemessage", data: data}).catch(err => {
        Toast.fail(err.message)
      })
      if (res) {
        Toast.success('留言成功')
        emailjs.send('service_mhj9vbb',
            apiKeys.TEMPLATE_ID,
            {
              to: "hztskj003@163.com",
              // to: "1054230914@qq.com",
              name: this.nameVal,
              topic: "碳索科技留言",
              phone: this.phoneVal,
              message: this.detailVal
            }, apiKeys.USER_ID).then(
            result => {
              console.log(result.text)
            },
            error => {
              console.log(error.text)
            }
        )
        this.detailVal = ''
        this.addrVal = ''
        this.emailVal = ''
        this.phoneVal = ''
        this.nameVal = ''
      }
    }
  },
  activated() {
    if (this.$route.path != '/home' && this.$store.state.gcal.length == 0)
      this.$router.replace("/home")
  },
  mounted() {
    this.getData()
  }
}
</script>

<style lang="less" scoped>
.main-content {
  display: flex;
  width: 1400px;
  min-width: 100%;
  flex-direction: column;

  .Maintop {
    background-color: white;
    z-index: 99;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;

    .top_1200 {
      width: 1360px;
      display: flex;
      min-width: 1400px;
      height: 110px;
      justify-content: space-between;
      align-items: flex-end;

      .logo {
        display: flex;
        align-items: center;
        height: 100%;
      }

    }

    .top_bbb {
      width: 100%;
      display: flex;
      //min-width: 1400px;
      background-color: #298ECD;
      height: 60px;
      align-items: center;
      justify-content: center;

      .nav_list {
        width: 1360px;
        display: flex;
        height: 100%;
        justify-content: space-between;

        .aaaa {
          padding-left: 30px;
          padding-right: 30px;
          width: max-content;
          display: flex;
          height: 100%;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          font-weight: 600;
          color: white;
        }

        .aaaa:hover, .aaaa-select {
          background-color: #3FA8E6;
        }
      }
    }
  }


  .main-footer {
    width: 100%;
    //min-width: 1400px;
    background-color: #3F4041;
    height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;

    .addr-wrap {
      display: flex;
      flex-direction: column;

      .bb-txt {
        color: white;
        font-size: 14px;
        font-weight: 600;
      }
    }

    img {
      margin-left: 350px;
      width: 100px;
      height: 100px;
    }
  }

  .liuyan-wrap {
    width: 240px;
    height: 350px;
    position: fixed;
    bottom: 2px;
    z-index: 99;
    left: 2px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #E5E5E5;
    border-radius: 5px;
    overflow: hidden;

    .title-wrap {
      width: 100%;
      background-color: #09ADF3;
      height: 35px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .title-txt {
        font-size: 16px;
        color: white;
        margin-left: 12px;
      }

      .close-txt {
        font-size: 20px;
        color: white;
        width: 35px;
        height: 35px;
        font-weight: bold;
        line-height: 35px;
        text-align: center;
        margin-left: 12px;
      }
    }

    .nb-nodeboard-set-content {
      width: 212px;
      height: 79px;
      margin-top: 10px;
      font-size: 14px;
      padding: 0 4px;
      resize: none;
      overflow: hidden;
      border: 1px solid #d5d5d5;
      background-color: #fff;
      text-align: left;
    }

    .imput-wrap {
      width: 212px;
      height: 30px;
      margin-top: 10px;
      background-color: white;

      .sfsd-img {
        width: 20px;
        height: 20px;
        margin-left: 5px;
      }

      .sidfjsiin {
        width: 140px;
        font-size: 14px;
        height: 30px;
        line-height: 30px;
        overflow: hidden;
        border: none;
        display: inline-block;
        margin-left: 5px;
      }


    }

    .comm-btn {
      width: 90px;
      height: 35px;
      background-color: #09ADF3;
      color: white;
      margin-left: 8px;
      margin-top: 10px;
      text-align: center;
      line-height: 35px;
    }
  }

  .title-show-wrap {
    width: 240px;
    position: fixed;
    bottom: 2px;
    z-index: 99;
    left: 2px;
    background-color: #09ADF3;
    border-top-right-radius: 5px;
    border-top-right-radius: 5px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title-txt {
      font-size: 16px;
      color: white;
      margin-left: 12px;
    }

    .close-txt {
      font-size: 20px;
      color: white;
      width: 35px;
      height: 35px;
      font-weight: bold;
      line-height: 35px;
      text-align: center;
      margin-left: 12px;
    }
  }

  .qq-open {
    width: 60px;
    border-radius: 100px;
    background: rgba(0, 0, 0, 0.3);
    position: fixed;
    bottom: 50px;
    right: 2px;
    padding-top: 10px;
    padding-bottom: 10px;
    z-index: 99;
    display: flex;
    align-items: center;
    flex-direction: column;

    .liuyan-open {
      width: 40px;
      height: 40px;
    }

    .open-qq-img {
      width: 40px;
      height: 40px;
    }
  }
}
</style>
